import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography, TextField, CircularProgress } from '@mui/material';
import { IconSearch, IconInfoCircle } from '@tabler/icons-react';
import { issueIcons } from '../../../constants/iconMappings';

/**
 * Step 2: Issue Selection
 */
const Step2Issue = ({
  issue,
  setIssue,
  setStep,
  issueSearchTerm,
  handleIssueSearchChange,
  issuesFromRedux,
  isLoadingIssues,
}) => {
  const filteredIssues = issueSearchTerm.trim()
    ? issuesFromRedux.filter(i => i.name.toLowerCase().includes(issueSearchTerm.toLowerCase()))
    : issuesFromRedux;

  return (
    <motion.div
      key="step2"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="step-content"
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '1rem' }} gutterBottom>
        Select an Issue
      </Typography>

      <TextField
        placeholder="Search issues..."
        variant="outlined"
        fullWidth
        size="small"
        value={issueSearchTerm}
        onChange={handleIssueSearchChange}
        InputProps={{
          startAdornment: <IconSearch size={18} style={{ marginRight: 8, opacity: 0.5 }} />
        }}
        sx={{ mb: 2 }}
        className="single-border-input"
      />

      <Box className="modal-issues-list-container">
        {filteredIssues.map((issueItem) => (
          <div
            key={issueItem.id}
            className={`issue-option ${issue?.id === issueItem.id ? 'selected' : ''}`}
            onClick={() => {
              setIssue(issueItem);
              setStep(3);
            }}
          >
            <div className="issue-option-content">
              <span className="issue-option-icon">
                {React.cloneElement(issueIcons[issueItem.id] || <IconInfoCircle size={18} />, { size: 18 })}
              </span>
              <span className="issue-option-label">{issueItem.name}</span>
              <div className="issue-option-radio">
                {issue?.id === issueItem.id && <div className="radio-dot"></div>}
              </div>
            </div>
            <div className="issue-option-description">
              {issueItem.description}
            </div>
          </div>
        ))}

        {isLoadingIssues && (
          <Box textAlign="center" py={2}>
            <CircularProgress size={24} />
          </Box>
        )}

        {!isLoadingIssues && issueSearchTerm.trim() && filteredIssues.length === 0 && (
          <Box textAlign="center" py={2}>
            <Typography variant="body2">No issues found matching "{issueSearchTerm}"</Typography>
          </Box>
        )}
      </Box>
    </motion.div>
  );
};

export default Step2Issue;
